import { isEmpty } from "lodash";
import { Download } from "react-feather";
import React, { useEffect, useState } from "react";
import {
  Button,
  Spinner,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Search from "../../../Shared/Search";
import {
  setAddCompetitorVideo,
  toggleAllTranscript,
  updateCampaignState,
  updateParams,
  updateVideoPageState,
} from "../VideoActions";
import { usePrevious } from "../../../Shared/CustomHooks";
import { AddVideosBtn } from "../../../Shared/Components/HeaderButtons";
import MultipleVideoDownloadDropdown from "../../../Shared/MultipleVideoDownloadDropdown";
import CampaignHeader from "./Campaign/CampaignHeader";
import ShowCampaignDetal from "./Campaign/ShowCampaignDetal";

const Tab = ({ tab, selected, dispatch }) => (
  <li
    key={tab}
    className="nav-tab-item"
    onClick={() => dispatch(updateParams({ tab: tab }))}
  >
    <div className={`nav-link-${selected ? "active" : "nonactive"}`}>
      <div>
        {tab.includes("Competition")
          ? "Competitors"
          : tab.includes("fan")
          ? "shopper"
          : tab}{" "}
      </div>
      {selected && <div className="nav-link-active-border" />}
    </div>
  </li>
);

const VideoPageHeader = ({
  search,
  setSearch,
  downloadHandle,
  uploadVideoDetails,
  setLimitReachedModal,
  setUploadVideoModal,
  setOpenMultiPublish,
  tabs,
  count,
  cardType,
}) => {
  const [openDownloadInfo, setOpenDownloadInfo] = useState(false);
  const [downloadDropdown, setDownloadDropdown] = useState(false);
  const [campaignDropdown, setCampaignDropdown] = useState(false);
  const [showPublish, setShowPublish] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const isAppManagerCategoryPage = useSelector(
    (state) => state.PublishedPageStates.isCategoryPage
  );
  const dispatch = useDispatch();

  const videoTab = useSelector((state) => state.videoParams.tab);
  const isFavoriteTab = useSelector((state) => state.videoParams.isFavoriteTab);
  const isFlaggedTab = useSelector((state) => state.videoParams.isFlaggedTab);
  const isTrashTab = useSelector((state) => state.videoParams.isTrashTab);
  const selectedBrand = useSelector(
    (state) => state.selectedBrandReducer.brand_id
  );
  const toggleTranscript = useSelector((state) => state.toggleTranscript);

  const transcriptView = useSelector((state) => state.videoData.transcriptView);
  const videoData = useSelector((state) => state.videoData);
  const roles = useSelector((state) => state.navbarStatsReducer.roles);
  const pro = useSelector(
    (state) => state.navbarStatsReducer.current_user.is_subscribed_to_vip
  );
  const loadingTranscriptPdf = useSelector(
    (state) => state.downloadTranscript.loadingTranscriptPdf
  );

  const isCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );

  const flaggedChecks = useSelector(
    (state) => state.videoPageStates.flaggedChecks
  );
  const favoriteChecks = useSelector(
    (state) => state.videoPageStates.favoriteChecks
  );
  const deleteChecks = useSelector(
    (state) => state.videoPageStates.deleteChecks
  );
  const restoreChecks = useSelector(
    (state) => state.videoPageStates.restoreChecks
  );
  const restoreVideosCheckList = useSelector(
    (state) => state.videoPageStates.restoreVideosCheckList
  );
  const flaggedVideosCheckList = useSelector(
    (state) => state.videoPageStates.flaggedVideosCheckList
  );
  const deleteVideosCheckList = useSelector(
    (state) => state.videoPageStates.deleteVideosCheckList
  );

  const favVideosCheckList = useSelector(
    (state) => state.videoPageStates.favVideosCheckList
  );

  const publishSelectAll = useSelector(
    (state) => state.videoPageStates.publishSelectAll
  );

  const publishVideosCheckList = useSelector(
    (state) => state.videoPageStates.publishVideosCheckList
  );

  const showCampaignHeader = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignHeader
  );
  // const isCampaignTab = videoTab === "Campaigns";
  const isCampaignTab = useSelector((state) => state.videoParams.isCampaignTab);

  //ispublished
  const videos = useSelector((state) => state.videos);
  const video = videos?.map((data) => data?.video);
  const publishedData = video?.map(
    (data) => data?.additional_data?.data?.published_to_swirl
  );
  const isPublishedSwirlArray = Array.isArray(publishedData);
  const isPublished =
    isPublishedSwirlArray &&
    publishedData.every(
      (status) => status === "Successfully updated published status"
    );

  const prevVideoTab = usePrevious(videoTab);
  // Reuse video for App-Manager
  const location = useLocation();
  const isAppManager = location.pathname === "/published";

  // Function to create breadcrumb

  const submitSearch = () => {
    if (search || (!search && transcriptView)) {
      dispatch(updateParams({ search, page: 1 }));
    }
  };

  const updateSearch = ({ target }) => setSearch(target.value);

  // on pressing Enter submit search
  const onKeyUp = ({ keyCode }) => {
    if (keyCode === 13) submitSearch();
  };

  const clearSearch = () => {
    setSearch("");
    if (transcriptView) {
      dispatch(updateParams({ search: "" }));
    }
  };

  useEffect(() => {
    if (!isFlaggedTab || selectedBrand) {
      // Reset for prev tab=flagged and checks enable OR brand change
      dispatch(
        updateVideoPageState({
          flaggedChecks: false,
          favoriteChecks: false,
          flaggedVideosCheckList: [],
          flagSelectAll: false,
          confirmUnflag: false,
          downloadVideoChecks: false,
          publishVideoChecks: false,
        })
      );
    }
  }, [isFlaggedTab, selectedBrand, videoTab]);

  useEffect(() => {
    //Flagged folder, switching tab
    if (videoTab !== prevVideoTab || isCategoryPage) {
      dispatch(
        updateVideoPageState({
          flagSelectAll: false,
          flaggedVideosCheckList: [],
          flaggedChecks: false,
        })
      );
    }
  }, [videoTab, isCategoryPage]);

  const showAllTranscript = () => {
    dispatch(toggleAllTranscript(!toggleTranscript));
  };

  const basic = roles?.includes("vip_brand_manager") && !pro;

  const toggleDropdown = () => setDownloadDropdown(!downloadDropdown);

  const toggleCampaignDropdown = () => {
    setCampaignDropdown(!campaignDropdown);
    if (!campaignDropdown) {
      setShowSubmenu(false);
    }
  };

  const toggleSubmenu = () => {
    setShowSubmenu(true);
  };
  const toggleSubmenuClose = () => {
    setShowSubmenu(false);
  };

  const AddVideos = (
    <div
      className="new-add-button"
      style={{ cursor: "pointer" }}
      disabled={isEmpty(uploadVideoDetails)}
      onClick={() => setUploadVideoModal(true)}
    >
      <div>
        <img
          role="button"
          src={require(`@src/assets/images/icons/add-videos-icon.png`).default}
          width={35}
        />
      </div>
      <div>Add Video</div>
    </div>
  );
  const handleCancelClick = (event) => {
    event.stopPropagation();
    setShowPublish(false);
    dispatch(
      updateVideoPageState({
        publishVideoChecks: false,
        publishVideosCheckList: [],
        publishSelectAll: false,
      })
    );
  };

  const handlePublishClick = () => {
    setShowPublish(true);
    dispatch(
      updateVideoPageState({
        publishVideoChecks: true,
        publishVideosCheckList: [],
        publishSelectAll: false,
      })
    );
  };

  const handlePublishModal = () => {
    if (showPublish && publishVideosCheckList?.length !== 0) {
      setShowPublish(false);
      dispatch(
        updateVideoPageState({
          openSinglePublish: true,
          publishVideoChecks: false,
        })
      );
    }
  };

  const handlePublishSelect = () => {
    // Filter out unpublished videos
    const unpublishedVideos = videos?.filter((data) => {
      const publishStatus = data?.additional_data?.data?.published_to_swirl;
      return publishStatus !== "Successfully updated published status";
    });

    dispatch(
      updateVideoPageState({
        publishSelectAll: true,
        publishVideosCheckList: [unpublishedVideos],
      })
    );
  };

  const handlePublishUnSelect = () => {
    dispatch(
      updateVideoPageState({
        publishSelectAll: false,
      })
    );
  };

  const SelectAll = (
    <div
      className="d-flex align-items-center ms-3"
      style={{
        fontSize: "18px",
        color: "#783AD0",
        cursor: "pointer",
      }}
    >
      {publishSelectAll ? (
        <div onClick={handlePublishUnSelect}>Unselect All</div>
      ) : (
        <div onClick={handlePublishSelect}>Select All</div>
      )}
    </div>
  );

  const publishButton = (
    <div className="d-flex align-items-center ms-3">
      <Button
        size="lg"
        color={`${publishVideosCheckList?.length === 0} ? secondary : primary`}
        onClick={handlePublishModal}
        disabled={publishVideosCheckList?.length === 0}
        style={{
          background:
            publishVideosCheckList?.length === 0 ? "#C4C4C4" : "#783AD0",
          color: "white",
          border: "0px",
          width: "126px",
          height: "39px",
          padding: "0px",
        }}
      >
        {isPublished ? (
          <img
            style={{ marginBottom: "6px" }}
            role="button"
            src={
              require(`@src/assets/images/vyrill/videos/unPublishedSwirll.png`)
                .default
            }
            width={18}
            alt="unPublish Icon"
          />
        ) : (
          <img
            role="button"
            src={
              require(`@src/assets/images/vyrill/videos/publishWhiteIcon.png`)
                .default
            }
            width={18}
            alt="Publish Icon"
          />
        )}
        <span style={{ marginLeft: "10px" }}>
          {isPublished ? "Unpublish" : "Publish"}
        </span>
      </Button>
    </div>
  );

  const PublishVideos = (
    <div
      className="d-flex align-items-center ms-3"
      style={{
        color: "grey",
        opacity: 0.5,
        pointerEvents: "none",
      }}
      onClick={handlePublishClick}
    >
      <div>
        {!showPublish && (
          <>
            {isPublished ? (
              <img
                style={{ marginBottom: "3px" }}
                role="button"
                src={
                  require(`@src/assets/images/vyrill/videos/unpublish-Icon.png`)
                    .default
                }
                width={18}
                alt="Publish Icon"
              />
            ) : (
              <img
                role="button"
                src={
                  require(`@src/assets/images/vyrill/videos/publishedSwirll.png`)
                    .default
                }
                width={18}
                alt="Publish Icon"
              />
            )}
          </>
        )}
      </div>
      <div style={{ fontSize: "18px", color: "#783AD0", marginLeft: "10px" }}>
        {!showPublish && (
          <> {isPublished ? "Unpublish Videos" : "Publish Videos"}</>
        )}
      </div>
      {showPublish && (
        <div
          style={{ fontSize: "18px", color: "#783AD0" }}
          onClick={handleCancelClick}
        >
          Cancel
        </div>
      )}
    </div>
  );

  // const showCampaignBtn = (
  //   <div
  //     className="new-add-button me-2"
  //     style={{ cursor: "pointer" }}
  //     onClick={() =>
  //       dispatch(updateCampaignState({ showCampaignHeader: true }))
  //     }
  //   >
  //     <div>
  //       <img
  //         role="button"
  //         src={
  //           require(`@src/assets/images/vyrill/icons/create-campaign.png`)
  //             .default
  //         }
  //         width={35}
  //       />
  //     </div>
  //     <div>Show Campaign Detail</div>
  //   </div>
  // );

  const AddCompetitorVideosBtn = (
    <Button
      color="primary"
      style={{ background: "white" }}
      disabled={isEmpty(uploadVideoDetails)}
      onClick={() => {
        if (!isEmpty(uploadVideoDetails)) {
          if (
            uploadVideoDetails?.video_upload_limit <=
            uploadVideoDetails?.uploaded_videos
          ) {
            setLimitReachedModal(true);
          } else {
            dispatch(setAddCompetitorVideo(true));
          }
        }
      }}
    >
      Add Competitor Video
    </Button>
  );

  const restoreHandler = () => {
    if (deleteChecks) {
      dispatch(
        updateVideoPageState({
          deleteVideosCheckList: [],
          restoreVideosCheckList: [],
          deleteChecks: false,
          restoreChecks: true,
        })
      );
    } else if (restoreChecks && restoreVideosCheckList.length) {
      dispatch(updateVideoPageState({ confirmRestore: true }));
    } else {
      dispatch(updateVideoPageState({ restoreChecks: true }));
    }
  };

  const downloadTrancriptBtn = videoData.count ? (
    <Button
      color="outline-primary ms-3"
      style={{ background: "white" }}
      onClick={showAllTranscript}
    >
      {!toggleTranscript ? "Show" : "Hide"} All Transcripts
    </Button>
  ) : null;

  const appManagerContent = !isAppManagerCategoryPage && (
    <>
      <div style={{ width: "24%" }}>
        <Search
          search={search}
          submitSearch={submitSearch}
          onKeyUp={onKeyUp}
          update={updateSearch}
          placeholder="Search Transcripts"
          clearSearch={clearSearch}
          searched={transcriptView}
          disabled={basic}
          videos
        />
      </div>

      <Button.Ripple
        color="primary"
        type="button"
        onClick={() => setOpenMultiPublish(true)}
        className="me-1"
      >
        <i className="fa-solid fa-arrow-down"></i> Unpublish from App
      </Button.Ripple>
    </>
  );

  const DownloadDropdownList = [
    {
      label: "Video",
      value: "video",
      items: [],
    },
    {
      label: "Transcript",
      value: "transcript",
      items: [
        {
          label: "Text",
          value: "text",
        },
        {
          label: "Pdf",
          value: "pdf",
        },
      ],
    },
  ];

  const downloadDropdownList = (
    <ButtonDropdown
      className="campaign-dropdown"
      isOpen={campaignDropdown}
      toggle={toggleCampaignDropdown}
    >
      <DropdownToggle outline color="#000000" className="new-add-button">
        <Download
          size={27}
          color="#783AD0"
          strokeWidth={1}
          onClick={toggleCampaignDropdown}
          disabled={loadingTranscriptPdf}
        />
        Download
      </DropdownToggle>
      <DropdownMenu>
        <div>
          <DropdownItem onMouseEnter={toggleSubmenuClose}>Video</DropdownItem>
          <DropdownItem divider />
        </div>
        <div>
          <DropdownItem onMouseEnter={toggleSubmenu}>
            Transcript
            <img
              height={9}
              src={require("@images/videos/expand-right-icon.png").default}
            />
          </DropdownItem>
        </div>
      </DropdownMenu>
      <div className="sub-campaign-dropdown">
        {showSubmenu && (
          <DropdownMenu>
            <div>
              <DropdownItem>txt</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>pdf</DropdownItem>
            </div>
          </DropdownMenu>
        )}
      </div>
    </ButtonDropdown>
  );

  const videoContent = (
    <>
      <div style={{ width: "24%" }}>
        <Search
          search={search}
          submitSearch={submitSearch}
          onKeyUp={onKeyUp}
          update={updateSearch}
          placeholder="Search Transcripts"
          clearSearch={clearSearch}
          searched={transcriptView}
          disabled={basic}
          videos
        />
      </div>

      <div>
        <div className="d-flex">
          {/* {!transcriptView &&
          videoTab !== "Competition" && */}
          {/* {!showCampaignHeader && videoTab === "Campaigns" && showCampaignBtn} */}
          {videoTab !== "Campaigns" &&
            videoTab !== "Competition" &&
            !showPublish &&
            AddVideos}
          {showPublish && SelectAll}
          {videoTab !== "Competition" && videos?.length > 0 && PublishVideos}
          {showPublish && publishButton}
          {videoTab === "Competition" && AddCompetitorVideosBtn}
          {/* {videoTab !== "Competition" && (
          <Button.Ripple
            color="outline-primary"
            type="button"
            style={{ marginLeft: "28px" }}
            onClick={() => setOpenMultiPublish(true)}
          >
            <i className="fa-solid fa-arrow-up" /> Publish to App
          </Button.Ripple>
        )} */}
          {/* {console.log(videoTab === "Campaigns")} */}
          {/* {videoTab === "Campaigns" && downloadDropdownList} */}
          {openDownloadInfo && (
            <div className="downlaod-transcript-tooltip">
              Download all transcripts
            </div>
          )}
          {videoTab !== "Campaigns" && !showPublish && (
            <span
              style={{ marginLeft: "15px" }}
              role="button"
              onMouseOver={() => setOpenDownloadInfo(true)}
              onMouseOut={() => setOpenDownloadInfo(false)}
            >
              {loadingTranscriptPdf ? (
                <Spinner size="sm" />
              ) : (
                <ButtonDropdown
                  className="multi-format-dropdown"
                  isOpen={downloadDropdown}
                  toggle={toggleDropdown}
                >
                  <DropdownToggle
                    outline
                    color="#000000"
                    className="new-add-button"
                  >
                    <Download
                      size={27}
                      color="#783AD0"
                      strokeWidth={1}
                      onClick={toggleDropdown}
                      disabled={loadingTranscriptPdf}
                    />
                    Download Transcript
                  </DropdownToggle>
                  <DropdownMenu>
                    {["txt", "pdf"].map((i) => (
                      <DropdownItem onClick={() => downloadHandle(i)} key={i}>
                        {i}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </ButtonDropdown>
              )}
            </span>
          )}
          {videoTab === "Campaigns" && videos?.length > 0 && !showPublish && (
            <div className="index-video-download-btn">
              <MultipleVideoDownloadDropdown
                transcriptDownloadHandle={downloadHandle}
                loadingTranscriptPdf={loadingTranscriptPdf}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );

  const flaggedTabContent = (
    <>
      <div>
        <ul
          className="page-nav-tab mb-0 mt-0"
          style={{ placeContent: "center" }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab}
              tab={tab}
              count={count}
              dispatch={dispatch}
              selected={tab === videoTab}
            />
          ))}
        </ul>
      </div>
      <div>
        {flaggedChecks ? (
          <>
            {flaggedVideosCheckList.length > 0 ? (
              <Button.Ripple
                color="primary"
                type="button"
                onClick={() => {
                  dispatch(updateVideoPageState({ confirmUnflag: true }));
                }}
              >
                Unflag
              </Button.Ripple>
            ) : (
              <span
                className="select-flagg-btn"
                onClick={() => {
                  dispatch(updateVideoPageState({ flagSelectAll: true }));
                }}
              >
                {"Select All"}
              </span>
            )}
          </>
        ) : (
          <span
            className="select-flagg-btn"
            onClick={() => {
              dispatch(updateVideoPageState({ flaggedChecks: true }));
            }}
          >
            {"Select"}
          </span>
        )}
      </div>
    </>
  );

  const favoriteTabContent = (
    <>
      <div>
        <ul
          className="page-nav-tab mb-0 mt-0"
          style={{ placeContent: "center" }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab}
              tab={tab}
              count={count}
              dispatch={dispatch}
              selected={tab === videoTab}
            />
          ))}
        </ul>
      </div>
      <div>
        {isFavoriteTab && (
          <>
            {favoriteChecks ? (
              <>
                {favVideosCheckList.length > 0 ? (
                  <Button.Ripple
                    color="primary"
                    type="button"
                    onClick={() => {
                      dispatch(updateVideoPageState({ confirmUnfav: true }));
                    }}
                  >
                    Unfavorite Videos
                  </Button.Ripple>
                ) : (
                  <span
                    className="select-flagg-btn"
                    onClick={() => {
                      dispatch(updateVideoPageState({ favSelectAll: true }));
                    }}
                  >
                    Select All
                  </span>
                )}
              </>
            ) : (
              <span
                className="select-flagg-btn"
                onClick={() => {
                  dispatch(
                    updateVideoPageState({
                      favoriteChecks: true,
                      favVideosCheckList: [],
                    })
                  );
                }}
              >
                Select
              </span>
            )}
          </>
        )}
      </div>
    </>
  );

  const cancelButton = (
    <Button
      color="btn btn-secondary ms-2"
      style={{ background: "white" }}
      onClick={() => {
        dispatch(
          updateVideoPageState({
            deleteChecks: false,
            restoreChecks: false,
            deleteVideosCheckList: [],
            restoreVideosCheckList: [],
          })
        );
      }}
    >
      Cancel
    </Button>
  );

  const trashTabContent = (
    <>
      <div>
        <ul
          className="page-nav-tab mb-0 mt-0"
          style={{ placeContent: "center" }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab}
              tab={tab}
              count={count}
              dispatch={dispatch}
              selected={tab === videoTab}
            />
          ))}
        </ul>
      </div>
      <div>
        {!restoreChecks && deleteChecks && (
          <Button.Ripple
            color="primary"
            type="button"
            disabled={deleteVideosCheckList.length === 0}
            onClick={() => {
              dispatch(updateVideoPageState({ confirmDelete: true }));
            }}
          >
            Delete Permanently
          </Button.Ripple>
        )}
        {!restoreChecks && !deleteChecks && (
          <Button.Ripple
            color="primary"
            type="button"
            onClick={() => {
              dispatch(
                updateVideoPageState({
                  deleteChecks: true,
                  restoreChecks: false,
                  deleteVideosCheckList: [],
                  restoreVideosCheckList: [],
                })
              );
            }}
          >
            Delete
          </Button.Ripple>
        )}
        {!deleteChecks && (
          <Button
            color="outline-primary ms-2"
            style={{ background: "white" }}
            onClick={restoreHandler}
            disabled={restoreChecks && restoreVideosCheckList.length === 0}
          >
            Restore
          </Button>
        )}

        {(deleteChecks || restoreChecks) && cancelButton}
      </div>
    </>
  );

  const renderSections = () => {
    if (isFlaggedTab && !isAppManager) {
      return flaggedTabContent;
    }
    if (isFavoriteTab && !isAppManager) {
      return favoriteTabContent;
    }
    if (isTrashTab && !isAppManager) {
      return trashTabContent;
    }
    if (isAppManager) {
      return appManagerContent;
    } else return videoContent;
  };

  // Render add btn for category page
  if (isCategoryPage && !isAppManager) {
    return null;
  }

  return (
    <>
      <div className="sub-header">{renderSections()}</div>
      {transcriptView && !videoData.loading && (
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            marginRight: "40px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              marginLeft: "40px",
            }}
          >
            Your search results were found in titles, notes, tags, transcripts,
            and summaries.
          </div>
          <div>{downloadTrancriptBtn}</div>
        </div>
      )}
      <ShowCampaignDetal />
      {/* {showCampaignHeader && (
        <div className="campaign-details-header">
          <CampaignHeader />
        </div>
      )} */}
    </>
  );
};

export default VideoPageHeader;
